import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Button } from "components/common/Button";
import type { FolderSuggestionHeaderProps } from "./types";

export const FolderSuggestionHeader = ({
  subtitle,
  isBusy,
  onSuggestAgain,
  onClose,
}: FolderSuggestionHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-3 flex flex-shrink-0 items-start justify-between gap-4">
      <div className="min-w-0">
        <h2 className="text-lg font-semibold text-gray-900">
          {t("smartSurveyor.folders.suggestion.title")}
        </h2>
        {subtitle !== null && (
          <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>
        )}
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        {onSuggestAgain !== undefined && (
          <Button
            size="sm"
            variant="outline"
            onClick={onSuggestAgain}
            disabled={isBusy}
            className="whitespace-nowrap"
          >
            {t("smartSurveyor.folders.suggestion.suggestAgain")}
          </Button>
        )}
        <Button
          size="sm"
          variant="text"
          onClick={onClose}
          disabled={isBusy}
          aria-label={t("smartSurveyor.common.close")}
          className="!p-1.5 !text-gray-500 hover:!text-gray-700"
        >
          <X size={18} />
        </Button>
      </div>
    </div>
  );
};
